import { replacePlaceholderValues } from "@resource/common";
import { useMemo } from "react";

type Interview = {
  id: string;
  replacementData: GraphQL_JSON;
  title: string;
  description: string;
};

export function useReplacedTitleAndDescriptionForInterviewItem({
  interview,
}: {
  interview: Interview;
}) {
  const titleAndDescription = useMemo(() => {
    const title = replacePlaceholderValues(
      interview.title,
      interview.replacementData
    );
    const description = replacePlaceholderValues(
      interview.description,
      interview.replacementData
    );
    return {
      title,
      description,
    };
  }, [interview]);

  return titleAndDescription;
}
